<footer class="footer">
    <div class="footer-container">
        <div class="footer-row">
            <!-- Column 1: Logo -->
            <div class="footer-col">
                <div class="footer-logo">
                    <img src="./assets/images/logo-o.png" alt="Farco Security Logo" class="logo-image">
                </div>
            </div>

            <!-- Column 2: Main Links -->
            <div class="footer-col">
                <div class="footer-links">
                    <a href="#" class="footer-link">Accueil</a>
                    <a href="#" class="footer-link">A propos</a>
                    <a href="#" class="footer-link">Services</a>
                    <a href="#" class="footer-link">Conditions</a>
                    <a href="#" class="footer-link">Contact</a>
                </div>
            </div>

            <!-- Column 3: Security Services -->
            <div class="footer-col">
                <div class="footer-links">
                    <a href="#" class="footer-link">Protection de bien mobilier et immobilier</a>
                    <a href="#" class="footer-link">Contrôle des personnes et d'accès</a>
                    <a href="#" class="footer-link">Sécurité événementielle</a>
                    <a href="#" class="footer-link">Gardiennage chantier</a>
                    <a href="#" class="footer-link">Gardiennage industriel</a>
                    <a href="#" class="footer-link">Accueil et gestion</a>
                </div>
            </div>

            <!-- Column 4: Contact Info -->
            <div class="footer-col">
                <div class="contact-info">
                    <div class="contact-item">
                        <img src="./assets/images/icons/profile/marker.png" alt="marker" width="14px" height="17px">
                        <div class="contact-content">
                            <span class="contact-label">Adresse :</span>
                            <div class="contact-details">
                                <p>Rue J. Vanderick 148 -6180 Courcelles</p>
                            </div>
                        </div>
                    </div>

                    <div class="contact-item">
                        <img src="./assets/images/icons/profile/mail.png" alt="mail" width="18px" height="14px">
                        <div class="contact-content">
                            <span class="contact-label">Email :</span>
                            <a href="mailto:info@farcosecurity.be" class="contact-detail link">info@farcosecurity.be</a>
                        </div>
                    </div>

                    <div class="contact-item">
                        <img src="./assets/images/icons/profile/phone.png" alt="phone" width="18px" height="18px">
                        <div class="contact-content">
                            <span class="contact-label">Numéro :</span>
                            <a href="tel:071686886" class="contact-detail link">071/68 68 86</a>
                        </div>
                    </div>

                    <div class="contact-item">
                        <img src="./assets/images/icons/profile/company.png" alt="company" width="20px" height="17px">
                        <div class="contact-content">
                            <span class="contact-label">Société</span>
                            <div class="contact-details">
                                <p> FARCO Security</p>
                                <p>AM 0687809281 / BE0687.809.281</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
        <!-- Social Media Links -->
        <div class="social-links">
            <a *ngFor="let social of socialLinks" [href]="social.url" class="social-link" target="_blank" [attr.aria-label]="social.name">
                <img [src]="social.icon" [alt]="social.name">
            </a>
        </div>

        <!-- Copyright -->
        <div class="copyright">
            Copyright © 2025 <strong>Farco Security</strong>. Tous droits réservés.
        </div>
    </div>
</footer>